import React from 'react';

interface IFullScreenProps {
  color?: string;
}
const FullScreenIcon = ({ color = '#fff' }: IFullScreenProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon-fullscreen"
      width="48"
      height="48"
      viewBox="0 0 32 32"
      fillRule="evenodd"
      fill={color}
    >
      <path d="M5 14H3V3h11v2H5zm22 0h2V3H18v2h9zm0 4h2v11H18v-2h9zM5 18H3v11h11v-2H5z" />
    </svg>
  );
};

export default FullScreenIcon;
